import React, { useState, useContext, useEffect } from 'react';
import classNames from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Drawer from '@material-ui/core/Drawer';
import UserSessionContext from 'context/UserSessionContext';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ImportContactsIcon from '@material-ui/icons/ImportContacts';
import GradeIcon from '@material-ui/icons/Grade';
import SettingsIcon from '@material-ui/icons/Settings';
import ThumbsUpDownIcon from '@material-ui/icons/ThumbsUpDown';
import BarChartIcon from '@material-ui/icons/BarChart';

import SidebarNav from './components/SidebarNav';
import { History } from '@material-ui/icons';
import useApi, { GET_RECENT_DASHBOARDS } from 'hooks/useApi';

const useStyles = makeStyles(theme => ({
  drawer: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.white
  },
  drawerClosed: {
    width: 70
  },
  drawerOpen: {
    width: 200
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  divider: {
    margin: theme.spacing(2, 0)
  },
  nav: {
    marginBottom: theme.spacing(2)
  }
}));

const Sidebar = () => {
  const apiParams = GET_RECENT_DASHBOARDS();
  const [responseState, makeRequest] = useApi();

  const { session } = useContext(UserSessionContext);
  const { portfolios, holdings, peerGroups, instruments, isAdmin } = session;
  const [isNavigationExpanded, setIsNavigationExpanded] = useState(false);
  const [menuState, setMenuState] = useState();

  const handleMenuClick = event => {
    if (!isNavigationExpanded) {
      setIsNavigationExpanded(true);
    }

    setMenuState(event.currentTarget.id);
  };

  useEffect(() => {
    if(isNavigationExpanded && menuState === 'Recent')
    makeRequest(apiParams)
  }, [isNavigationExpanded, menuState])

  const handleNavigationHover = () => {
    setIsNavigationExpanded(true);
  };

  const handleNavigationClose = () => {
    setIsNavigationExpanded(false);
    setMenuState();
  };

  const classes = useStyles();

  const pages = [
    {
      title: 'Dashboard',
      icon: <DashboardIcon />,
      data: [
        {
          to: '/my-dashboards',
          title: 'My dashboards',
          id: 1
        },
        {
          to: '/shared-dashboards',
          title: ' Dashboards Shared with me',
          id: 2
        }
      ]
    },
    {
      title: 'Recent',
      icon: <History />,
      isPortfolio: true,
      data: responseState && !responseState.isLoading
        ? responseState.error
          ? [{ title: 'Error occured', id:0 }]
          : responseState.data && responseState.data.length > 0
            ? [...responseState.data]
            : [{ title: 'No recent dashboards found.', id:0 }]
        : null
    },
    {
      title: 'Portfolios',
      icon: <ImportContactsIcon />,
      isPortfolio: true,
      data: [...portfolios]
    },
    {
      title: 'Holdings',
      icon: <GradeIcon />,
      data: [...holdings],
      isPortfolio: true
    },
    {
      title: 'Peer Groups',
      icon: <ThumbsUpDownIcon />,
      data: [...peerGroups],
      isPortfolio: true
    },
    {
      title: 'Instruments',
      icon: <BarChartIcon />,
      data: [...instruments],
      isPortfolio: true
    },
    {
      title: 'Admin',
      icon: <SettingsIcon />,
      data: [
        {
          to: '/admin/users',
          title: 'Admin Dashboard',
          id: 11
        }
      ]
    }
  ];

  return (
    <Drawer
      anchor="left"
      classes={{
        paper: isNavigationExpanded
          ? classNames(classes.drawer, classes.drawerOpen)
          : classNames(classes.drawer, classes.drawerClosed)
      }}
      open={isNavigationExpanded}
      variant="permanent"
      onMouseEnter={handleNavigationHover}
      onMouseLeave={handleNavigationClose}
    >
      <div className={classes.root}>
        <SidebarNav
          isAdmin={isAdmin}
          className={classes.nav}
          isOpen={isNavigationExpanded}
          pages={pages}
          handleMenuClick={handleMenuClick}
          menuState={menuState}
        />
      </div>
    </Drawer>
  );
};

export default Sidebar;
